import HttpClienteToken from '../../services/HttpClientToken';

import { TipoAmparoProps } from '../../interfaces/catalogos/TipoAmparoInterface';

export const TipoAmparo = () => {

    return new Promise<TipoAmparoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoAmparo/', token)
            .then( ({ data } : { data : TipoAmparoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoAmparo = () => {

    return new Promise<TipoAmparoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoAmparo/ObtenerTipoAmparo', token)
            .then( ({ data } : { data : TipoAmparoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoAmparo = ( params: TipoAmparoProps ) => {

    return new Promise<TipoAmparoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoAmparo/Actualizar', params, token)
            .then( ({ data } : { data : TipoAmparoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoAmparo: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoAmparo = ( params: TipoAmparoProps ) => {

    return new Promise<TipoAmparoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoAmparo/Agregar', params, token)
            .then( ({ data } : { data : TipoAmparoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoAmparo: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}